export default __webpack_public_path__ + "static/avatar-kayi-sketch-1-7375be2581cae1c13bf04967c4bfa67f.png";